import React from 'react';
import PropTypes from 'prop-types';
import GenericIcon from './fontIcons/genericIcon';
import './fontIcons/fontIconStyle.css';

const ProfileIcon = ({ ...props }) => {
  const { color, size } = props;
  return <GenericIcon color={color} size={size} fontClass="icon-ic_user" />;
};

ProfileIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};

export default ProfileIcon;
